<template>
  <o-section
    :level="level + 1"
    :title="label || schema.verbose_name"
    body-classes="p-0"
    not-closable
  >
    <o-item-editable-table
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
      v-model="items"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'repair_material')">
          {{ schema.fields.repair_material.label }}
        </th>
        <th v-if="canSee(schema, 'quantity_used')">
          {{ schema.fields.quantity_used.label }}
        </th>
        <th v-if="canSee(schema, 'cost_per_item')">
          {{ schema.fields.cost_per_item.label }}
        </th>
        <th v-if="canSee(schema, 'total_cost')">
          {{ schema.fields.total_cost.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'repair_material')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="repair_material"
          >
            <o-select
              :form-state="formState"
              :items="optionCodeRepairMaterialItems"
              :loading="optionCodeRepairMaterialWorking"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              add-title="Create New"
              allow-add
              name="repair_material"
              nolabel
              sort-field="description"
              store-name="CodeRepairMaterial"
              text-field="description"
              v-bind="schema.fields.repair_material"
              v-model="items[index].repair_material"
              value-field="id"
              @input="calculate_field_values(items[index], null)"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <code-repair-material-form
                  :form-state="formState"
                  :item="item"
                  :server-errors="serverErrors"
                  in-modal
                ></code-repair-material-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'quantity_used')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="quantity_used"
          >
            <o-text-field
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="quantity_used"
              nolabel
              v-bind="schema.fields.quantity_used"
              v-model="items[index].quantity_used"
              @input="calculate_field_values(items[index], null)"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'cost_per_item')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="cost_per_item"
          >
            <o-text-field
              prepend="$"
              :form-state="formState"
              :server-errors="_se"
              :server-errors-index="index"
              :validators="validators.$each[index]"
              name="cost_per_item"
              nolabel
              v-bind="schema.fields.cost_per_item"
              v-model="items[index].cost_per_item"
              @input="
                calculate_field_values(items[index], items[index].cost_per_item)
              "
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'total_cost')">
          <o-widget-wrapper
            :form-state="formState"
            :schema="schema"
            :server-errors="_se"
            :server-errors-index="index"
            :validators="validators.$each[index]"
            name="total_cost"
          >
            <o-money-field
              :prepend="moneySymbol"
              v-model="item.total_cost"
              nolabel
              :form-state="formState"
              name="total_cost"
              :server-errors="_se"
              :no-rows="true"
              v-bind="schema.fields.total_cost"
              readonly
            ></o-money-field>
          </o-widget-wrapper>
        </td>
      </template>

      <template v-if="show_bottom_row()" slot="o-bottom-row">
        <tr>
          <td colspan="3">Sub Total</td>
          <td>
            <o-money-field
              :value="calculate_total(items)"
              :prepend="moneySymbol"
              nolabel
              :form-state="formState"
              name="sub_total"
              :server-errors="_se"
              :no-rows="true"
              readonly
            ></o-money-field>
          </td>
        </tr>
        <tr>
          <td colspan="3">Total GST</td>
          <td>
            <o-money-field
              :value="total_gst"
              :prepend="moneySymbol"
              nolabel
              :form-state="formState"
              name="total_gst"
              :server-errors="_se"
              :no-rows="true"
              readonly
            ></o-money-field>
          </td>
        </tr>
        <tr>
          <td colspan="3">Total Materials Cost (Inc GST)</td>
          <td>
            <o-money-field
              :value="total_materials_cost"
              :prepend="moneySymbol"
              nolabel
              :form-state="formState"
              name="total_materials_cost"
              :server-errors="_se"
              :no-rows="true"
              readonly
            ></o-money-field>
          </td>
        </tr>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import schema from "../../schema/index";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../vue-ocom/mixins";
import OItemEditableTable from "../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../vue-ocom/components/layout/OSection";

import OMoneyField from "../../components/money_field/OMoneyField";

export default {
  name: "RepairMaterialsUsedFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("RepairMaterialsUsed"),
    CreateCodeTableFetchMixin(["CodeRepairMaterial"]),
  ],
  components: { OItemEditableTable, OSection, OMoneyField },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
    create: { type: Boolean, default: false },
  },
  data: function () {
    return {
      moneySymbol: "$",
      schemaModel: cleanUpModel(
        schema.RepairMaterialsUsed,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.RepairMaterialsUsed),
      total_gst: 0,
      total_materials_cost: 0,
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
    calculate_field_values(item, custom_cost_per_item) {
      if (custom_cost_per_item) {
        item.total_cost = item.quantity_used * custom_cost_per_item;
      } else {
        var repairMaterial = this.optionCodeRepairMaterialItemsById[
          item.repair_material
        ];
        item.cost_per_item = repairMaterial.price;
        item.total_cost = item.quantity_used * item.cost_per_item;
      }
      item.total_cost = item.total_cost.toFixed(2);
    },
    calculate_total(items) {
      var sub_total = 0;
      for (var i = 0; i < items.length; i++) {
        sub_total += parseFloat(items[i].total_cost) || 0;
      }

      this.total_gst = (sub_total * 0.1).toFixed(2);
      this.total_materials_cost = (sub_total * 1.1).toFixed(2);
      return sub_total.toFixed(2);
    },
    show_bottom_row() {
      // create form
      if (this.create && this.items != null) return true;
      // edit form
      if (!this.create && this.items && this.items.length > 0) return true;
      else return false;
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>
